import { Link } from "react-router-dom";
import { Checkbox } from "@/components/ui/checkbox";

/**
 * The agreement a customer makes before any money moves.
 *
 * One component, used by **both** payment surfaces — the cart (several documents at once) and the
 * Pay button on a case page (one document, bypassing the cart). A consent that guards one of the
 * two ways to pay guards nothing, and these two panels have drifted before: the address picker
 * had to be added to the case page after direct payments were found recording no address at all.
 *
 * **The link opens in a new tab.** Everything chosen on the way to this point — which items are
 * ticked, which address to deliver to — is component state that does not survive leaving the
 * page, so making someone spend their cart to read the terms is how the terms go unread. The
 * disclaimer's own Back control handles the in-app case (see pages/Disclaimer.jsx); this one
 * simply never leaves.
 *
 * `stopPropagation` on the link because the label forwards clicks to the checkbox: without it,
 * opening the terms would silently tick the box that says you have read them.
 */
export default function TermsAgreement({ checked, onChange, testId = "terms-agree" }) {
  return (
    <div className="flex gap-2 items-start mt-4">
      <Checkbox id={testId} data-testid={testId} checked={checked}
                onCheckedChange={(v) => onChange(v === true)} className="mt-0.5 shrink-0" />
      <label htmlFor={testId} className="text-xs leading-relaxed text-[#A0AABF] cursor-pointer">
        I agree to be bound by the{" "}
        <Link to="/disclaimer" target="_blank" rel="noopener noreferrer" data-testid={`${testId}-link`}
              onClick={(e) => e.stopPropagation()}
              className="underline text-[#CBA96C] hover:opacity-80">Terms and Conditions</Link>
        {" "}of DharmaTN.
      </label>
    </div>
  );
}
